import { render, staticRenderFns } from "./TagSelect.vue?vue&type=template&id=5fd3655d"
import script from "./TagSelect.vue?vue&type=script&lang=js"
export * from "./TagSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/shorlyn/Documents/project/core/campus-all/rccms-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5fd3655d')) {
      api.createRecord('5fd3655d', component.options)
    } else {
      api.reload('5fd3655d', component.options)
    }
    module.hot.accept("./TagSelect.vue?vue&type=template&id=5fd3655d", function () {
      api.rerender('5fd3655d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Form/common/TagSelect.vue"
export default component.exports